/**
 * Defines an extension of the Stateful class that allows properties to have per-window values
 */
define([
    "dojo/_base/declare",
    "dojo/Stateful"
], function (declare, Stateful) {

    /**
     * @class PerWindowStateful
     */
    return declare([Stateful], {

        setForWindow: function(window, key, value) {
            this.set(this._composeKey(window, key), value);
        },

        getForWindow: function(window, key) {
            return this.get(this._composeKey(window, key));
        },

        watchForWindow: function(window, key, callback) {
            return this.watch(this._composeKey(window, key), callback);
        },

        _composeKey: function (window, key) {
            return (window.name || "") + key;
        }
    });
});